// Owner branding. Set defaultServer to your panel URL to pre-fill the login,
// and tweak name / accent to re-brand the whole app.
export const BRAND = {
  name: "Xstream",
  // Pre-filled on the login screen so viewers only type username + password.
  defaultServer: "http://cassy.chunkyfunky.org",
  // Direct (non-Cloudflare) host used for Play/Download so streaming isn't blocked.
  // Leave empty to stream from the same host used to sign in.
  streamServer: "http://more.cocopop.uk",
  accent: "#14A3FF",
  accentHover: "#0E8FE6",
  // Horizontal lockup used in the header and on the sign-in screen
  logoUrl: "/logo.png",
};
